import { defineComponent, toRefs } from "@vue/composition-api";
import DeleteElementIcon from "@Client/@Modules/application-standalone/components/helpers/delete-element-icon.vue";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import CurrencyField from "@Shared/components/form-elements/fields/currency-field.vue";
import SelectField from "@Shared/components/form-elements/fields/select-field.vue";
import PercentageField from "@Shared/components/form-elements/fields/percentage-field.vue";
import DateField from "@Shared/components/form-elements/fields/date-field.vue";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import CheckboxField from "@Shared/components/form-elements/fields/checkbox-field.vue";
import { APPLICATION_FIELD_OPTIONS } from "@Shared/@Utils/application-defaults-utils/global-field-options";
import { useSubjectPropertyHelpers } from "@Client/@Composables/application-standalone/pages/subject-property/useSubjectPropertyHelpers";
import { subjectPropertyExistingMortgageBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/subject-property/subjectPropertyExistingMortgageBindingsAndVisibilities";
import { subjectPropertyExistingMortgageValidator } from "@Client/@Composables/application-standalone/validations/subjectPropertyExistingMortgageValidator";
import { get } from "lodash";
export default defineComponent({
  components: {
    CurrencyField,
    SelectField,
    PercentageField,
    DateField,
    TextField,
    DeleteElementIcon,
    SectionTitle,
    CheckboxField
  },
  props: {
    existingMortgageIndex: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const {
      existingMortgageIndex
    } = toRefs(props);
    const {
      mortgageTypeOptions,
      mortgageFrequencyOptions,
      mortgageRateTypeOptions,
      mortgageTermTypeOptions,
      mortgagePayoffOptions,
      mortgageLoanTypeOptions,
      mortgageInsuranceProviderOptions
    } = APPLICATION_FIELD_OPTIONS();
    const {
      bindings,
      visibilities
    } = subjectPropertyExistingMortgageBindingsAndVisibilities(existingMortgageIndex);
    const {
      existingMortgageBalanceRemaining,
      existingMortgageBlendedAmortization,
      existingMortgageCurrentMortgageNumber,
      existingMortgageFrequency,
      existingMortgageInsured,
      existingMortgageInterestRate,
      existingMortgageLender,
      existingMortgageLoanType,
      existingMortgageMaturityDate,
      existingMortgageMortgageInsuranceProviderId,
      existingMortgageMortgageType,
      existingMortgageOrigAmount,
      existingMortgagePaymentAmount,
      existingMortgagePayoff,
      existingMortgageRateType,
      existingMortgageTermType,
      existingMortgageRefiAdditionalInfo,
      existingMortgageInsuranceAccountNumber
    } = bindings;
    const {
      deleteExistingMortgage
    } = useSubjectPropertyHelpers();
    const handleDeleteExistingMortgage = () => {
      deleteExistingMortgage(existingMortgageIndex.value);
    };
    const {
      propertyExistingMortgageBalanceRemainingVisible,
      propertyExistingMortgageBlendedAmortizationVisible,
      propertyExistingMortgageCurrentMortgageNumberVisible,
      propertyExistingMortgageFrequencyVisible,
      propertyExistingMortgageInsuredVisible,
      propertyExistingMortgageInterestRateVisible,
      propertyExistingMortgageLenderVisible,
      propertyExistingMortgageLoanTypeVisible,
      propertyExistingMortgageMaturityDateVisible,
      propertyExistingMortgageMortgageInsuranceProviderIdVisible,
      propertyExistingMortgageMortgageTypeVisible,
      propertyExistingMortgageOrigAmountVisible,
      propertyExistingMortgagePaymentAmountVisible,
      propertyExistingMortgagePayoffVisible,
      propertyExistingMortgageRateTypeVisible,
      propertyExistingMortgageTermTypeVisible,
      propertyExistingMortgageRefiAdditionalInfoVisible,
      propertyExistingMortgageInsuranceAccountNumberVisible,
      existingMortgagesIsVisible
    } = visibilities;
    const {
      v$
    } = subjectPropertyExistingMortgageValidator(existingMortgageIndex);
    const getValidator = path => get(v$.value, path, null);
    return {
      existingMortgageBalanceRemaining,
      existingMortgageBlendedAmortization,
      existingMortgageCurrentMortgageNumber,
      existingMortgageFrequency,
      existingMortgageInsured,
      existingMortgageInterestRate,
      existingMortgageLender,
      existingMortgageLoanType,
      existingMortgageMaturityDate,
      existingMortgageMortgageInsuranceProviderId,
      existingMortgageMortgageType,
      existingMortgageOrigAmount,
      existingMortgagePaymentAmount,
      existingMortgagePayoff,
      existingMortgageRateType,
      existingMortgageTermType,
      existingMortgageInsuranceAccountNumber,
      existingMortgageRefiAdditionalInfo,
      mortgageTypeOptions,
      mortgageFrequencyOptions,
      mortgageRateTypeOptions,
      mortgageTermTypeOptions,
      mortgagePayoffOptions,
      mortgageLoanTypeOptions,
      mortgageInsuranceProviderOptions,
      handleDeleteExistingMortgage,
      propertyExistingMortgageBalanceRemainingVisible,
      propertyExistingMortgageBlendedAmortizationVisible,
      propertyExistingMortgageCurrentMortgageNumberVisible,
      propertyExistingMortgageFrequencyVisible,
      propertyExistingMortgageInsuredVisible,
      propertyExistingMortgageInterestRateVisible,
      propertyExistingMortgageLenderVisible,
      propertyExistingMortgageLoanTypeVisible,
      propertyExistingMortgageMaturityDateVisible,
      propertyExistingMortgageMortgageInsuranceProviderIdVisible,
      propertyExistingMortgageMortgageTypeVisible,
      propertyExistingMortgageOrigAmountVisible,
      propertyExistingMortgagePaymentAmountVisible,
      propertyExistingMortgagePayoffVisible,
      propertyExistingMortgageRateTypeVisible,
      propertyExistingMortgageTermTypeVisible,
      propertyExistingMortgageRefiAdditionalInfoVisible,
      propertyExistingMortgageInsuranceAccountNumberVisible,
      existingMortgagesIsVisible,
      v$,
      getValidator
    };
  }
});